// Server config and API endpoint constants

if (!process.env.REACT_APP_API_URL) {
    throw new Error('[config] REACT_APP_API_URL is not set. Check your .env file.');
}

export const BASE_API_URL = process.env.REACT_APP_API_URL;
export const VERSION = '5.28.0'; // removed leading space

// ─── API endpoint paths ───────────────────────────────────────────────────────
export const MASTER_DATA            = '/api/v1/masterData';
export const MASETR_DATA_TEMPLATE   = '/api/v1/masterData/downloadExport'; // NOTE: typo in name kept for backwards compatibility
export const PROJECT                = '/api/v1/projects';
export const PROJECT_DELETE_CONFIRM = '/api/v1/projects/deleteProjectConfirmation';
export const SURVEY_LIST            = '/api/v1/surveys/surveyLookup';
export const SURVEY                 = '/api/v1/surveys';
export const SURVEY_DELETE_CONFIRM  = '/api/v1/surveys/deleteSurveyConfirmation';
export const ORGANIZATION           = '/api/v1/org';
export const ORG_ANALYTICS          = '/api/v1/orgAnalytics';
export const PLATFORM_ANALYTICS     = '/api/v1/platformAnalytics';
export const LOGIN                  = '/api/v1/user/login';
export const USER_LIST              = 'user';
export const USER                   = 'user';
export const ROLE_LOOKUP            = 'roles';
export const IMAGE                  = '/api/v1/formSubmission/image/';
export const SIGNATURE              = '/api/v1/formSubmission/signature/';
export const AUDIO                  = '/api/v1/formSubmission/audio/';

// ─── File upload constraints ──────────────────────────────────────────────────
export const MAX_UPLOAD_FILE_SIZE = 1 * 1024 * 1024; // 1 MB
export const ALLOWED_UPLOAD_FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const ALLOWED_UPLOAD_EXTENSIONS = '.xlsx';